import React, { useState } from "react";
import "./Register.css";
import { Link } from "react-router-dom";

const Register = () => {

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    mobile: "",
    email: "",
    shop_name: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://rcfinder.online/api/register.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      console.log(data);

      if (data.status === "success") {
        alert("Registration Successful 🎉");
      } else {
        alert(data.message);
      }

    } catch (error) {
      alert("Server Error ❌");
    }
  };

  return (
    <div className="register-page">
      
      <div className="register-container">

        {/* LEFT FORM */}
        <div className="register-left">
          <h2>Create Account</h2>

          <form onSubmit={handleSubmit}>

            <input type="text" name="first_name" placeholder="First Name" required onChange={handleChange} />
            <input type="text" name="last_name" placeholder="Last Name" required onChange={handleChange} />
            <input type="text" name="mobile" placeholder="Mobile Number" required onChange={handleChange} />
            <input type="email" name="email" placeholder="Email Address" required onChange={handleChange} />
            <input type="text" name="shop_name" placeholder="Shop Name" required onChange={handleChange} />
            <input type="password" name="password" placeholder="Create Password" required onChange={handleChange} />

            <button type="submit" className="submit-btn">Register</button>
          </form>
        </div>

        {/* RIGHT PANEL */}
        <div className="register-right">
          <h1>Welcome to RC Finder!</h1>
          <p>
            Create your account and access Vehicle RC, DL & PAN services instantly. 
            Secure • Fast • Trusted 🔥
          </p>

          <span className="login-text">
            Already have an account? <Link to="/login"><strong>Login</strong></Link>
          </span>

        </div>

      </div>

    </div>
  );
};

export default Register;
